import classNames from 'classnames';
import { MaterialIcons } from '@/common/components/shared/material-icons';

interface Sort {
  desc: boolean;
}

interface Props {
  isFieldActive: boolean;
  label: string;
  sort: Sort | null;
  onSort: (desc: boolean) => void;
}

export const SortableHeader = ({ label, isFieldActive, sort, onSort }: Props) => {
  return (
    <div className="flex items-center space-x-1.5">
      <span>{label}</span>
      <div className="flex flex-col content-between">
        <div className="h-3 overflow-hidden">
          <MaterialIcons
            iconName="arrow_drop_up"
            fontSize="16px"
            weight={700}
            grade={200}
            className={classNames('-mb-1 cursor-pointer hover:text-gray-9', {
              'text-blue-6': isFieldActive && !sort?.desc,
              'text-gray-6': !isFieldActive || (isFieldActive && sort?.desc),
            })}
            onClick={() => onSort(false)}
          />
        </div>
        <div className="h-3 overflow-hidden">
          <MaterialIcons
            iconName="arrow_drop_down"
            fontSize="16px"
            weight={700}
            grade={200}
            className={classNames('-mt-1 cursor-pointer hover:text-gray-9', {
              'text-blue-6': isFieldActive && sort?.desc,
              'text-gray-6': !isFieldActive || (isFieldActive && !sort?.desc),
            })}
            onClick={() => onSort(true)}
          />
        </div>
      </div>
    </div>
  );
};
